import type { PeriodFilter } from '~/types/types'
import { defineStore } from 'pinia'
import { useNuxtApp } from '#app'
import { type Ref } from 'vue'
import { useStorage } from '@vueuse/core'
import { RemovableRef } from '@vueuse/shared'
import { Moment } from 'moment'

export const useFilterStore = defineStore('filter', () => {
  const { $moment, $_ } = useNuxtApp()

  const userStore = useUserStore()

  const reportingPeriods = ref<PeriodFilter[]>([])

  const getReportingPeriods = computed(() => {
    const rp = reportingPeriods.value.map((period: PeriodFilter) => ({
      key: useUniqueId('period_'),
      name: `${$moment(period.from).format('DD.MM.YYYY')} - ${$moment(period.to).format('DD.MM.YYYY')}`,
      from: period.from,
      to: period.to,
    }))

    rp.push({
      key: useUniqueId('period_'),
      name: $_('period-select.all-periods'),
      from: null,
      to: null,
    })

    return rp.reverse()
  })

  const selectedReportingPeriod: Ref = ref<RemovableRef<{ key: string; name: string; from: Moment; to: Moment }>>(
    useStorage('selectedReportingPeriod', useFirst(getReportingPeriods.value))
  )

  const fetchReportingPeriod = async () => {
    if(!userStore?.activeSubject?.id) return

    const response = await useApi(`/catalog/${userStore?.activeSubject?.id}/reporting-period`)

    if (!response.error.value) {
      const data: any = response.data.value

      reportingPeriods.value = data.items.map(period => ({
        from: period.start,
        to: period.end,
      }))
    }

    return response
  }

  const setSelectedReportingPeriod = (period: PeriodFilter | null) => {
    selectedReportingPeriod.value = period
  }

  return {
    reportingPeriods,
    selectedReportingPeriod,
    getReportingPeriods,
    fetchReportingPeriod,
    setSelectedReportingPeriod,
  }
})
